var render = function () {
  var _vm$global$profile;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.$route.name ? _c('v-app', {
    class: {
      'hide-app': _vm.isIE,
      'iframe': _vm.IS_IFRAME
    },
    attrs: {
      "dark": ""
    }
  }, [_vm.global.notify ? _c('snackbar', _vm._b({
    attrs: {
      "value": !!_vm.global.notify
    },
    on: {
      "input": function ($event) {
        _vm.global.notify = null;
      }
    }
  }, 'snackbar', _vm.global.notify.props, false), [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.global.notify.msg)
    }
  })]) : _vm._e(), _vm.showSignIn ? _c('sign-in-dialog', {
    model: {
      value: _vm.showSignIn,
      callback: function ($$v) {
        _vm.showSignIn = $$v;
      },
      expression: "showSignIn"
    }
  }) : _vm._e(), _c('snackbar', {
    attrs: {
      "top": "",
      "center": "",
      "min-width": "0",
      "color": "warning",
      "value": !!_vm.checkPromoCodeMsg
    }
  }, [_vm._v(_vm._s(_vm.checkPromoCodeMsg))]), !!_vm.promoCode && !_vm.checkPromoCodeStatus.pending && !_vm.checkPromoCodeMsg ? [!_vm.isSignedIn ? _c('sign-in-dialog', {
    attrs: {
      "value": true
    },
    on: {
      "input": _vm.handlePromoCodeSignIn
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c('div', [_vm._v("Sign in to apply this promo code to your account")])];
      },
      proxy: true
    }, {
      key: "subtitle",
      fn: function () {
        return [_c('code', {
          staticClass: "d-inline-block overline"
        }, [_vm._v(_vm._s(_vm.promoCode))])];
      },
      proxy: true
    }], null, false, 2995891586)
  }) : !_vm.applyPromoCodeStatus.rejected ? _c('v-dialog', {
    directives: [{
      name: "no-scroll",
      rawName: "v-no-scroll"
    }],
    attrs: {
      "value": true,
      "persistent": "",
      "width": "500"
    },
    on: {
      "input": _vm.stripPromoCode
    }
  }, [_c('v-card', [_c('v-card-title', [_vm.applyPromoCodeStatus.pending ? _c('div', {
    staticClass: "font-italic ml-2"
  }, [_vm._v("Checking promo code…")]) : !!_vm.applyPromoCodeMsg ? _c('div', {
    staticClass: "warning--text"
  }, [_vm._v("Invalid promo code")]) : _c('div', [_vm._v("Promo code accepted")])]), _c('v-card-text', [_vm.applyPromoCodeStatus.pending ? _c('div', [_c('v-progress-circular', {
    attrs: {
      "indeterminate": ""
    }
  })], 1) : !!_vm.applyPromoCodeMsg ? _c('div', [_vm._v("Could not apply promo code "), _c('code', [_vm._v(_vm._s(_vm.promoCode))]), _vm._v(" — " + _vm._s(_vm.applyPromoCodeMsg))]) : _c('div', [_vm._v("The promo code "), _c('code', [_vm._v(_vm._s(_vm.promoCode))]), _vm._v(" has been added to "), _c('router-link', {
    attrs: {
      "to": {
        name: 'account'
      },
      "target": "_blank"
    }
  }, [_vm._v("your account")]), _vm._v(". It will be automatically applied at checkout.")], 1)]), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": _vm.applyPromoCodeStatus.pending
    },
    on: {
      "click": _vm.stripPromoCode
    }
  }, [_vm._v("Close")])], 1)], 1)], 1) : _c('error-dialog', {
    attrs: {
      "status": _vm.applyPromoCodeStatus
    }
  })] : _vm._e(), _vm.sections.header ? _c('v-navigation-drawer', {
    directives: [{
      name: "no-scroll",
      rawName: "v-no-scroll"
    }],
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "app": "",
      "right": "",
      "disable-resize-watcher": "",
      "color": "grey lighten-5"
    },
    model: {
      value: _vm.showNavMenu,
      callback: function ($$v) {
        _vm.showNavMenu = $$v;
      },
      expression: "showNavMenu"
    }
  }, [_c('v-list', {
    staticClass: "py-0"
  }, [_c('v-list-item', {
    staticClass: "pa-2 ec-light-blue",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "d-block",
    attrs: {
      "height": "56",
      "src": "/ellacard-logo.png",
      "alt": "Ellacard",
      "title": "Ellacard"
    }
  }), _c('v-spacer'), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "active-class": "before-opacity-0",
      "large": "",
      "icon": "",
      "color": "pink",
      "to": {
        name: 'catalog-video'
      }
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.showNavMenu = false;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiVideoVintage)
    }
  })], 1), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "active-class": "before-opacity-0",
      "large": "",
      "icon": "",
      "color": "pink",
      "to": {
        name: 'catalog'
      }
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.showNavMenu = false;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCards)
    }
  })], 1)], 1), _c('v-divider'), _c('v-list-item', {
    attrs: {
      "to": {
        name: 'account'
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "ec-dark-blue"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.isSignedIn ? _vm.mdiAccountCheck : _vm.mdiAccount)
    }
  }), _c('v-list-item-content', {
    staticClass: "ml-3"
  }, [_c('v-list-item-title', {
    staticClass: "ec-dark-blue--text text-body-2"
  }, [_vm._v("Account")]), _c('v-list-item-subtitle', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.isSignedIn ? _vm.global.profile.email : 'Not signed in')
    }
  })], 1)], 1), _c('v-list-item', {
    on: {
      "click": function ($event) {
        _vm.showPending = _vm.showPending == 'side' ? null : 'side';
      }
    }
  }, [_c('div', {
    staticClass: "flex-shrink-0"
  }, [_vm.loadPendingOrdersStatus.pending ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "ec-dark-blue",
      "size": "24",
      "width": "2"
    }
  }) : _c('v-icon', {
    attrs: {
      "color": "ec-dark-blue"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCart)
    }
  })], 1), _c('v-list-item-title', {
    staticClass: "ml-3 text-body-2 ec-dark-blue--text"
  }, [_vm._v(" Saved projects ")]), _c('v-list-item-action', [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.showPending == 'side' ? _vm.mdiMenuUp : _vm.mdiMenuDown)
    }
  })], 1)], 1), _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showPending == 'side' && !_vm.loadPendingOrdersStatus.pending,
      expression: "(showPending == 'side') && !loadPendingOrdersStatus.pending"
    }],
    staticClass: "overflow-auto",
    staticStyle: {
      "max-height": "372px"
    }
  }, [_vm._l(_vm.pendingOrders, function (_ref) {
    var orderId = _ref[0],
        order = _ref[1];
    return _c('cart-list-item', {
      key: 'side-' + orderId,
      attrs: {
        "order-id": orderId,
        "order": order,
        "to": {
          name: 'project',
          params: {
            orderId: orderId,
            routeOnClose: _vm.$routeAssign({})
          }
        }
      }
    });
  }), !_vm.pendingOrders.length ? _c('div', {
    staticClass: "pl-13 py-3 text--label-active font-italic"
  }, [_vm._v("No saved projects")]) : _vm._e()], 2)]), _c('v-divider'), _vm._l(_vm.navMenus, function (component, i) {
    return _c(component, {
      key: 'list-' + i,
      tag: "component",
      attrs: {
        "disabled": _vm.menu != -1 && _vm.menu != i
      },
      on: {
        "spotlight": function (v) {
          return _vm.menu = v ? i : _vm.menu == -1 || _vm.menu == i ? -1 : _vm.menu;
        }
      }
    });
  }), _c('v-divider'), _vm._l([['featured', 'Featured cards', _vm.mdiTrophy], ['batch-order', 'Batch order', _vm.mdiCalendarMultiselect], ['design', 'Design program', _vm.mdiImageSizeSelectLarge], ['pricing', 'Pricing', _vm.mdiCurrencyUsd], ['faq', 'Faq', _vm.mdiFrequentlyAskedQuestions], ['blog', 'Blog', _vm.mdiFormatFloatLeft], ['site-map', 'More', _vm.mdiDotsHorizontal]], function (_ref2) {
    var name = _ref2[0],
        title = _ref2[1],
        icon = _ref2[2];
    return _c('v-list-item', {
      key: name,
      staticClass: "ec-dark-blue--text",
      attrs: {
        "to": {
          name: name
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "ec-dark-blue"
      },
      domProps: {
        "innerHTML": _vm._s(icon)
      }
    }), _c('v-list-item-title', {
      staticClass: "ml-3 text-body-2",
      domProps: {
        "innerHTML": _vm._s(title)
      }
    })], 1);
  }), _c('v-divider'), _c('v-list-item', {
    attrs: {
      "href": "mailto:contact@ellacard.com"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "ec-dark-blue"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiEmail)
    }
  }), _c('v-list-item-content', {
    staticClass: "ml-3"
  }, [_c('v-list-item-title', {
    staticClass: "ec-dark-blue--text text-body-2"
  }, [_vm._v("Contact us")]), _c('v-list-item-subtitle', [_vm._v("contact@ellacard.com")])], 1)], 1), _c('v-divider')], 2), (_vm$global$profile = _vm.global.profile) !== null && _vm$global$profile !== void 0 && _vm$global$profile.admin ? [_c('div', {
    staticClass: "overline pt-2 px-4 mb-n2"
  }, [_vm._v("Admin")]), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.$router.options.routes.find(function (x) {
    return x.name == 'admin';
  }).children.map(function (x) {
    return x.name.substr(6);
  }), function (name) {
    return _c('v-list-item', {
      key: name,
      attrs: {
        "to": {
          name: 'admin-' + name
        }
      }
    }, [_c('v-list-item-title', {
      staticClass: "font-italic",
      domProps: {
        "innerHTML": _vm._s(name)
      }
    })], 1);
  }), 1)] : _vm._e()], 2) : _vm._e(), _vm.isLoaded ? _c('v-main', [_vm.sections.header ? _c('div', {
    staticClass: "relative mb-2",
    staticStyle: {
      "background": "linear-gradient(#edf6fc, #FFF)"
    }
  }, [_c('div', {
    staticClass: "nav-btns pa-3 d-flex justify-end"
  }, [_c('div', {
    staticClass: "flex-grow-1 ma-n2 ma-lg-1 overflow-visible",
    staticStyle: {
      "max-height": "1px"
    },
    attrs: {
      "active-class": "transparent"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'start'
      }
    }
  }, [_c('img', {
    style: {
      height: {
        xl: 80,
        lg: 72,
        md: 64,
        sm: 64,
        xs: 56
      }[_vm.$vuetify.breakpoint.name] + 'px'
    },
    attrs: {
      "src": "/ellacard-logo.png",
      "alt": "Ellacard",
      "title": "Ellacard"
    }
  })])], 1), _vm.$vuetify.breakpoint.smAndUp ? _c('div', {
    staticClass: "flex-grow-1 d-flex justify-end justify-md-center",
    class: {
      'absolute-fill pa-3': _vm.$vuetify.breakpoint.lgAndUp
    },
    staticStyle: {
      "pointer-events": "none"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "pointer-events": "auto",
      "text-transform": "none"
    },
    attrs: {
      "active-class": "before-opacity-0",
      "text": "",
      "color": "pink",
      "aria-label": "View all cards",
      "to": {
        name: 'catalog'
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCards)
    }
  }), _c('span', {
    staticClass: "ml-2 hidden-sm-and-down"
  }, [_vm._v("View all cards")])], 1)], 1) : _vm._e(), _vm.isSignedIn ? _c('v-menu', {
    attrs: {
      "eager": "",
      "bottom": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref3) {
        var _vm$$route$matched$;

        var on = _ref3.on,
            attrs = _ref3.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "text": "",
            "color": "ec-dark-blue",
            "aria-label": "Account",
            "input-value": ((_vm$$route$matched$ = _vm.$route.matched[0]) === null || _vm$$route$matched$ === void 0 ? void 0 : _vm$$route$matched$.name) == 'account'
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiAccountCheck)
          }
        }), _c('div', {
          staticClass: "mx-1 hidden-xs-only",
          staticStyle: {
            "max-width": "30vw",
            "overflow": "hidden",
            "text-transform": "none"
          }
        }, [_vm._v(" " + _vm._s(_vm.global.profile.email) + " ")]), _c('v-icon', {
          staticClass: "mx-n1",
          domProps: {
            "innerHTML": _vm._s(_vm.mdiMenuDown)
          }
        })], 1)];
      }
    }], null, false, 1189262457)
  }, [_c('v-list', {
    staticClass: "py-0 grey lighten-5"
  }, [_c('v-list-item', {
    attrs: {
      "exact": "",
      "to": {
        name: 'account'
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "ec-dark-blue"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAccount)
    }
  }), _c('v-list-item-content', {
    staticClass: "ml-3"
  }, [_c('v-list-item-title', {
    staticClass: "ec-dark-blue--text text-body-2"
  }, [_vm._v("Account")]), _vm.$vuetify.breakpoint.xsOnly ? _c('v-list-item-subtitle', {
    domProps: {
      "textContent": _vm._s(_vm.global.profile.email)
    }
  }) : _vm._e()], 1)], 1), _vm._l([['Cards you ordered', 'account-orders'], ['Cards you signed', 'account-signed'], ['Cards you received', 'account-received'], ['Ellacard contacts', 'account-contacts']], function (_ref4) {
    var title = _ref4[0],
        name = _ref4[1];
    return _c('v-list-item', {
      key: name,
      staticClass: "pl-13",
      attrs: {
        "to": {
          name: name
        }
      }
    }, [_c('v-list-item-title', {
      staticClass: "ec-dark-blue--text text-body-2",
      domProps: {
        "innerHTML": _vm._s(title)
      }
    })], 1);
  }), _c('v-divider'), _c('v-list-item', {
    attrs: {
      "to": {
        name: 'account-design'
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "ec-dark-blue"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiImageSizeSelectLarge)
    }
  }), _c('v-list-item-title', {
    staticClass: "ml-3 ec-dark-blue--text text-body-2"
  }, [_vm._v("Design portal")])], 1), _c('v-divider'), _c('v-list-item', {
    attrs: {
      "to": {
        name: 'account-org'
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "ec-dark-blue"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiDomain)
    }
  }), _c('v-list-item-title', {
    staticClass: "ml-3 ec-dark-blue--text text-body-2"
  }, [_vm._v("Business portal")])], 1), _c('v-divider'), _c('v-list-item', {
    on: {
      "click": function ($event) {
        _vm.global.jwt = null;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "ec-dark-blue"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiLogout)
    }
  }), _c('v-list-item-title', {
    staticClass: "ml-3 ec-dark-blue--text text-body-2"
  }, [_vm._v("Sign out")])], 1)], 2)], 1) : _c('v-btn', {
    attrs: {
      "text": "",
      "color": "ec-dark-blue",
      "aria-label": "Sign in"
    },
    on: {
      "click": function ($event) {
        _vm.showSignIn = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAccount)
    }
  }), _c('div', {
    staticClass: "ml-1 hidden-xs-only",
    staticStyle: {
      "text-transform": "none"
    }
  }, [_vm._v("Sign in")])], 1), _c('v-menu', {
    attrs: {
      "bottom": "",
      "offset-y": "",
      "close-on-content-click": "",
      "min-width": "300",
      "value": _vm.showPending == 'top'
    },
    on: {
      "input": function (x) {
        return _vm.showPending = x ? 'top' : null;
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref5) {
        var on = _ref5.on,
            attrs = _ref5.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "pr-2",
          attrs: {
            "text": "",
            "color": "ec-dark-blue",
            "aria-label": "Cart / projects",
            "loading": _vm.showPending == 'top' && _vm.loadPendingOrdersStatus.pending
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiCart)
          }
        }), _c('v-icon', {
          staticClass: "mx-n1",
          domProps: {
            "innerHTML": _vm._s(_vm.mdiMenuDown)
          }
        })], 1)];
      }
    }], null, false, 1702693217)
  }, [_c('v-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.loadPendingOrdersStatus.pending,
      expression: "!loadPendingOrdersStatus.pending"
    }],
    staticClass: "py-0 grey lighten-5"
  }, [_c('div', {
    staticClass: "text--label-active pa-2"
  }, [_vm._v("Saved projects")]), _vm._l(_vm.pendingOrders, function (_ref6) {
    var orderId = _ref6[0],
        order = _ref6[1];
    return _c('cart-list-item', {
      key: orderId,
      staticClass: "pl-0",
      attrs: {
        "order-id": orderId,
        "order": order,
        "to": {
          name: 'project',
          params: {
            orderId: orderId,
            routeOnClose: _vm.$routeAssign({})
          }
        }
      }
    });
  }), !_vm.pendingOrders.length ? _c('div', {
    staticClass: "pa-3 text--label-active font-italic"
  }, [_vm._v("No saved projects")]) : _vm._e()], 2)], 1), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "ec-dark-blue",
      "aria-label": "Navigation menu",
      "input-value": _vm.showNavMenu
    },
    on: {
      "click": function ($event) {
        _vm.showNavMenu = !_vm.showNavMenu;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiMenu)
    }
  })], 1)], 1), _vm.$vuetify.breakpoint.smAndUp ? _c('div', {
    staticClass: "mb-4 pa-3 flex-grow-1 d-flex flex-wrap align-center justify-center"
  }, _vm._l(_vm.navMenus, function (component, i) {
    return _c(component, {
      key: 'head-' + i,
      tag: "component",
      attrs: {
        "header": "",
        "disabled": !_vm.showNavMenu && _vm.menu != -1 && _vm.menu != i
      },
      on: {
        "spotlight": function (v) {
          return _vm.menu = v ? i : _vm.menu == -1 || _vm.menu == i ? -1 : _vm.menu;
        }
      }
    });
  }), 1) : _vm._e()]) : _vm._e(), _c('router-view', {
    on: {
      "hook:mounted": function ($event) {
        _vm.routerViewMounted = true;
      }
    }
  })], 1) : _vm._e(), _vm.sections.footer ? _c('v-footer', {
    attrs: {
      "dark": "",
      "tile": ""
    }
  }, [_c('div', {
    staticClass: "flex-grow-1 overline"
  }, [_c('div', {
    staticClass: "my-2 float-right"
  }, [_vm._v("© 2022")]), _c('div', {
    staticClass: "my-2 white--text"
  }, [_vm._v("Ellacard, LLC")]), _c('div', {
    staticClass: "mx-n2 d-flex flex-wrap"
  }, [_c('router-link', {
    staticClass: "ma-2 white--text",
    attrs: {
      "to": "/start"
    }
  }, [_vm._v("Start")]), _c('router-link', {
    staticClass: "ma-2 white--text",
    attrs: {
      "to": "/faq"
    }
  }, [_vm._v("FAQ")]), _c('router-link', {
    staticClass: "ma-2 white--text",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")]), _c('router-link', {
    staticClass: "ma-2 white--text",
    attrs: {
      "to": "/privacy-policy"
    }
  }, [_vm._v("Privacy Policy")]), _c('router-link', {
    staticClass: "ma-2 white--text",
    attrs: {
      "to": "/terms-and-conditions"
    }
  }, [_vm._v("Terms and Conditions")]), _c('router-link', {
    staticClass: "ma-2 white--text",
    attrs: {
      "to": "/site-map"
    }
  }, [_vm._v("Site map")]), _c('a', {
    staticClass: "ma-2 white--text",
    attrs: {
      "href": "mailto:contact@ellacard.com"
    }
  }, [_vm._v("contact@ellacard.com")])], 1), _c('div', {
    staticClass: "mx-n2 d-flex flex-wrap"
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "icon": "",
      "aria-label": "Facebook",
      "href": "https://www.facebook.com/ellacard/",
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.mdiFacebook))])], 1), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "icon": "",
      "aria-label": "Instagram",
      "href": "https://instagram.com/ellacard_co",
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.mdiInstagram))])], 1), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "icon": "",
      "aria-label": "LinkedIn",
      "href": "https://www.linkedin.com/company/ellacard",
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.mdiLinkedin))])], 1), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "icon": "",
      "aria-label": "Pinterest",
      "href": "https://www.pinterest.com/ellacard_co/",
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.mdiPinterest))])], 1), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "icon": "",
      "aria-label": "Twitter",
      "href": "https://twitter.com/ellacard_co",
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.mdiTwitter))])], 1)], 1)])]) : _vm._e(), _vm.showCookieWarning ? _c('cookie-warning') : _vm._e()], 2) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }